import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20medical%20health%20education%20background%20with%20soft%20organic%20flowing%20shapes%20in%20warm%20golden%20and%20earthy%20green%20tones%2C%20clean%20minimalist%20composition%2C%20professional%20healthcare%20atmosphere%2C%20subtle%20abstract%20anatomical%20references%2C%20calm%20and%20trustworthy%20feeling&width=1600&height=900&seq=hero-main-2026&orientation=landscape"
        alt="前列腺健康知识科普"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight max-w-4xl">
          前列腺健康知识科普
        </h1>
        <p className="text-base md:text-lg text-background-50/90 max-w-2xl mb-8 leading-relaxed">
          深度解析前列腺高潮的生理原理、刺激方式与安全注意事项，以科学、专业、负责任的态度，帮助成年男性全面了解自身身体，探索健康生活。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/anatomy"
            className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
          >
            开始学习
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/safety"
            className="px-6 py-3 bg-background-50/20 hover:bg-background-50/30 text-background-50 backdrop-blur-sm rounded-full font-medium text-sm transition-colors whitespace-nowrap cursor-pointer border border-background-50/30"
          >
            安全须知
            <i className="ri-shield-check-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}